import type { Credentials, CredentialsFetcher } from '@wizbii-utils/angular/algolia';
import type { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Store } from '@ngrx/store';
import { roles } from '@wizbii-utils/angular/stores';
import { filter, switchMap, take } from 'rxjs';

@Injectable()
export class AlgoliaCredentialsService implements CredentialsFetcher {
  readonly #http = inject(HttpClient);
  readonly #store = inject(Store);

  public fetchCredentials(): Observable<Credentials> {
    return this.#store.select(roles).pipe(
      filter((roles) => !!roles && roles.length > 0),
      take(1),
      switchMap(() => this.#http.get<Credentials>(`${environment.api.obendy}/v3/_credentials/algolia`))
    );
  }
}
